import { useTranslation } from 'react-i18next';
import 'twin.macro';

const chipStyles = {
  1: { labelKey: 'notStarted', bg: 'white', border: '#BDC4C9', text: '#656565' },
  2: { labelKey: 'current', bg: '#EEF3FF', border: '#285FF5', text: '#285FF5' },
  3: { labelKey: 'incomplete', bg: '#FFF6E9', border: '#FC9D14', text: '#FC9D14' },
  4: { labelKey: 'skipped', bg: '#FFF1F2', border: '#D12E3C', text: '#D12E3C' },
  5: { labelKey: 'completed', bg: '#EBFDF5', border: '#0B834F', text: '#0B834F' },
};

const StatusChip = ({ status }) => {
  const { t } = useTranslation('exercise');
  const style = chipStyles[status];
  if (!style) {
    return null;
  }

  return (
    <div
      tw="inline-flex items-center max-h-[24px] min-h-[24px] px-[8px] py-[3px] rounded-[100px] border"
      style={{ backgroundColor: style.bg, borderColor: style.border }}
    >
      <p
        tw="text-[13px] leading-[18px] tracking-[0.16px] whitespace-nowrap"
        style={{ color: style.text }}
      >
        {t(`statusChip.${style.labelKey}`)}
      </p>
    </div>
  );
};

export default StatusChip;
